module.exports = __webpack_public_path__ + "img/SOKAL-SRS-120921-Clarity-Modern.a345ad57.jpeg";